
import React from "react";
import Home from "./Components/Home/Home";
import Header from "./Components/Header/Header";


function App() {
  return (
      <div>
<Header/>
          <Home/>


      </div>
  );
}


export default App;
